import { useEffect, useState } from "react";

import { Stack, Typography } from "@mui/material";

import { useRoleContext, useShipmentQuotes } from "hooks";
import { getBookedQuoteFromQuotes } from "utils";

interface Props {
  shipment: CondensedShipment;
}

export function GeneralShipmentBookedBy(props: Props) {
  const { shipment } = props;
  const [bookedBy, setBookedBy] = useState<string | null>(null);
  const [bookedByCompany, setBookedByCompany] = useState<string | null>(null);
  const [carrierEmail, setCarrierEmail] = useState<string | null>(null);
  const { quotes } = useShipmentQuotes(shipment.info.id);
  const { role } = useRoleContext();

  useEffect(() => {
    if (role?.type === "SHIPPER" && quotes.length > 0) {
      const booked = getBookedQuoteFromQuotes(quotes);
      if (booked?.created_by && booked?.created_by_company) {
        setBookedBy(
          `${booked.created_by.first_name} ${booked.created_by.last_name}`,
        );
        setBookedByCompany(booked.created_by_company.name);
      }
      // only shippers get access to carrier email
      if (booked?.created_by?.email) {
        setCarrierEmail(booked.created_by.email);
      }
    }
  }, [quotes, role]);

  useEffect(() => {
    if (
      role?.type === "CARRIER" &&
      shipment.shipment_company &&
      shipment.shipment_creator
    ) {
      setBookedBy(
        `${shipment.shipment_creator.first_name} ${shipment.shipment_creator.last_name}`,
      );
      setBookedByCompany(shipment.shipment_company.name);
    }
  }, [role, shipment]);

  if (!bookedBy || !bookedByCompany) {
    return null;
  }

  return (
    <Stack direction="column">
      <Typography variant="body1">
        <b>
          {role?.type === "SHIPPER"
            ? "Main carrier contact: "
            : "Main shipper contact: "}
        </b>
        {bookedBy}
        <b> from </b>
        {bookedByCompany}
      </Typography>
      {carrierEmail && <Typography variant="body1">{carrierEmail}</Typography>}
    </Stack>
  );
}
